import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AppHeader } from "@/components/app/header";

export const Route = createFileRoute("/_authed")({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isSignedIn) {
      throw redirect({
        to: "/sign-in/$",
        params: { _splat: "" },
        search: { redirect: location.href },
      });
    }
    if (!context.auth.orgId) {
      throw redirect({ to: "/select-org" });
    }
    // No workspace check: GET /workspaces/me auto-creates on miss (D11
    // fallback in the API), so it never returns null. The only path to
    // /onboarding is Clerk's forceRedirectUrl after sign-up.
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  // Fixed viewport height: header pins, the body is the scroll container.
  // Without `h-dvh + overflow-hidden` the outer flex grows with content and
  // pushes the page scrollbar instead of the inner one.
  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-background text-foreground">
      <AppHeader />
      <main className="flex-1 overflow-auto">
        <div className="mx-auto w-full max-w-7xl p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
